import type { FC, ReactNode, FormEvent } from 'react';

interface FormProps {
    onSubmit: (event: FormEvent<HTMLFormElement>) => void;
    children: ReactNode;
    className?: string;
    // Opt-in escape hatch for forms driving their own react-hook-form + Zod validation UI.
    // Without it, native HTML5 constraint attributes (e.g. an <input type="number" max="…">
    // rendered out of catalogue bounds) silently block the browser's submit event before it
    // ever reaches React, so a custom Zod field error is never shown and onSubmit never runs.
    // Defaults to false so existing Form consumers keep native validation unchanged.
    noValidate?: boolean;
}

export const Form: FC<FormProps> = ({ onSubmit, children, className, noValidate = false }) => {
    return (
        <form
            onSubmit={(event) => {
                event.preventDefault(); // Prevent default form submission
                onSubmit(event);
            }}
            className={className} // Caller-provided spacing/layout classes; omitted when unset
            noValidate={noValidate}
        >
            {children}
        </form>
    );
};
